import linkClickTracker from './linkClickTracker.directive';

export default function initGtmTracking(app: any) {
    linkClickTracker(app);
}
